module.exports = __webpack_public_path__ + "static/media/06 Bass Clarinet Region 20 Scales.b55cc573.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/middleSchool/scales/06 Bass Clarinet Region 20 Scales.pdf
// module id = 266
// module chunks = 0